export const eventConstants = {
  EVENT_RESCHEDULING: 'EVENT_RESCHEDULING',
  EVENT_GET_SUCCESS: 'EVENT_GET_SUCCESS',
  EVENT_GET_FAILURE: 'EVENT_GET_FAILURE',
  EVENT_GET_REQUEST: 'EVENT_GET_REQUEST',
  EVENT_INIT_LOAD: 'EVENT_INIT_LOAD',
  EVENT_ADD_ITEM: 'EVENT_ADD_ITEM',
}